import React from 'react';
import { Pane, Badge, Text, Pill, majorScale } from 'evergreen-ui';

/**
 * A custom Steps component to display a step-by-step progress indicator
 *
 * @param {Object} props - Component props
 * @param {number} props.currentStep - The current active step (0-based index)
 * @param {Array} props.steps - Array of step objects with title property
 * @param {Object} props.containerProps - Additional props for the container Pane
 */
const Steps = ({ currentStep, steps, containerProps = {} }) => {
  return (
    <Pane
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      {...containerProps}
    >
      {steps.map((step, index) => {
        const isActive = index === currentStep;
        const isCompleted = index < currentStep;

        return (
          <Pane
            key={index}
            display="flex"
            flexDirection="column"
            alignItems="center"
            width={`${100 / steps.length}%`}
            position="relative"
          >
            {/* Connector line */}
            {index < steps.length - 1 && (
              <Pane
                position="absolute"
                height={2}
                top={16}
                right={0}
                width="50%"
                backgroundColor={isCompleted ? "success" : "muted"}
                zIndex={1}
              />
            )}
            {index > 0 && (
              <Pane
                position="absolute"
                height={2}
                top={16}
                left={0}
                width="50%"
                backgroundColor={isCompleted || (isActive && index > 0) ? "success" : "muted"}
                zIndex={1}
              />
            )}

            {/* Step indicator */}
            <Pill
              display="flex"
              alignItems="center"
              justifyContent="center"
              width={32}
              height={32}
              borderRadius="50%"
              color={isActive ? "white" : isCompleted ? "white" : "default"}
              backgroundColor={isActive ? "blue" : isCompleted ? "success" : "muted"}
              marginBottom={8}
              zIndex={2}
            >
              {isCompleted ? "✓" : index + 1}
            </Pill>

            {/* Step title */}
            <Text
              size={300}
              fontWeight={isActive ? 600 : 400}
              color={isActive ? "default" : isCompleted ? "success" : "muted"}
              textAlign="center"
            >
              {step.title}
            </Text>
          </Pane>
        );
      })}
    </Pane>
  );
};

export default Steps;
